var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{attrs:{"to":'/category/' + _vm.categoryIdent}},[_c('li',{staticClass:"menu__items-item"},[_c('div',{staticClass:"menu__thumbnail",style:(_vm.styles)}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.categoryName))])])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71fb82e3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MenuItem.vue
// module id = null
// module chunks = 